import React, { FC } from 'react'
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types'
import { StringInputViewModel } from '@sitecore-jss/sitecore-jss-forms'

import BaseTextField from '../baseTextField'

const TelephoneField: FC<ValueFieldProps<StringInputViewModel>> = (props) => (
  <BaseTextField type="tel" {...props} />
)

export default TelephoneField
